import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
import { propertyRoutes } from './routes';

/** One property's AppFolio mapping, as much of it as the bill views read. */

export class AppfolioProperties {
  constructor() {
    _defineProperty(this, "routes", propertyRoutes);
  }
  /**
   * Every AppFolio-mapped property of the company, in one call. Read whole rather than per property:
   * a bill can cover several, and `createAsync` cancels the previous call on the same action, so
   * asking one at a time would leave every answer but the last cancelled.
   */
  async listProperties(options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getDefaultChargeOnDate(data, options) {
    const allocationCycleMonth = data.allocationCycleMonth,
      allocationCycleYear = data.allocationCycleYear,
      propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).post("".concat(this.routes.defaultChargeOnDate(propertyId)), {
      allocationCycleMonth,
      allocationCycleYear
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}